import { Component, OnInit, NgModule } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import {Observable, of} from 'rxjs';
import {delay, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { stringify } from 'querystring';
import {AppComponent} from '../../app.component';
import { AlertService } from '../../alertpopup/_alert';
export class Company {
  Name: string;
  Address: string;
  StateID: string;
  CityID: Int16Array;
  Email1: string;
  Email2: string;
  Mobile: string;
  WorkPhone1: string;
  WorkPhone2: string;
  Fax: string;
  recEnable: Int16Array;
  id: string;
}

@Injectable({
  providedIn: 'root'
})
@Component({
    selector: 'app-company-master',
    templateUrl: './company-master.component.html',
    styleUrls: ['./company-master.component.css'],
    standalone: false
})
export class CompanyMasterComponent implements OnInit {
  State: any;
  City: any;
  url: string;
  pageurl: string;
  numb: any;
  id: any;
  typ: any;
  address: string;
  buttonname: string;
  pageHeader: string;
  companyName: string;
  HideOrganizationTr: string;
  disableButton: any;
  GenID: string;
  GID: string;
  MID: string;
  addFormCompany: FormGroup;
  submitted: any;
  status: string;
  getdata: string;
  pagehead: any;
  disabled: boolean;
  RightsID: string;
  RouteGMCity: string;
  RouteGMState: string;
  options = {
    autoClose: true,
    keepAfterRouteChange: false
  };
  constructor( private router: Router, private http: HttpClient, private formBuilder: FormBuilder, protected alertService: AlertService) {
    this.url = AppComponent.baseURL; }
  ngOnInit() {
    this.RightsID = localStorage.getItem('UserRight');
    if (this.RightsID.includes('202044001') || this.RightsID.includes('202044021') || this.RightsID.includes('202044000')) {
    } else {
      window.location.href = "module/0";
    }
    this.pageurl = this.router.url;
    this.pagehead = this.pageurl.split('/');
    this.id = this.pagehead[3];
    this.typ = this.pagehead[2];
    this.HideOrganizationTr = "!isHidden";
    this.getMasterData();
    if (this.id == '0')  {
      this.ContactFetch();
    }
    if (this.id !== '0') {
      this.FetchExistingContactOrg();
    }
    this.submitted = false;
    this.addFormCompany = this.formBuilder.group({
     companyName: ['', Validators.required], address: ['', Validators.required], MobileNumber: ['', Validators.required], State: ['', Validators.required], workphone: [''], City: ['', Validators.required], workphone2: [''],
     faxno: [''], email1: ['', Validators.required], email2: ['']
    });
    this.addFormCompany.patchValue({
      State: null ,  City: null
    });
    this.fetchRouteDataRights();
  }
  get f() { return this.addFormCompany.controls; }
  fetchRouteDataRights() {
   if (this.RightsID.includes('202042000') || this.RightsID.includes('202042001') || this.RightsID.includes('202042021')) {
     this.RouteGMCity = "general-master/015";
     this.RouteGMState = "general-master/010";
    } else {
      this.RouteGMCity = "module/0";
      this.RouteGMState = "module/0";
    }
    } 
   ContactFetch()  {
      this.pageHeader = 'Create New Company';
      this.buttonname = 'ADD';
      this.HideOrganizationTr = "";
   }
  onStateSelect(value) {
    this.getMaster('015', value.hdID).subscribe( (data: any) => {
      this.City = data ; });
  }
   getMaster(GID: string, MID: string) {
    return this.http.get(this.url + 'GM/GetMaster?GenID=' + GID + '&MainID=' + MID)
    .pipe(map(data => data = (data == null ? null : JSON.parse(data.toString()))));
    }
  getMasterData() {
     this.getMaster('010', '') .subscribe( (data: any) => {
      this.State = data; });
  }
  onClickSubmit(formData1) {
    this.submitted = true;
    if (this.addFormCompany.invalid) { 
      this.addFormCompany.markAllAsTouched();
      return; }
    let pagehead1 = this.router.url.split('/');
    this.disableButton = true;
    this.numb = 1;
    let CompanyDetail: Company = {
      Name: formData1.companyName,
      Address: formData1.address,
      StateID: formData1.State,
      CityID: formData1.City,
      Email1: formData1.email1,
      Email2: formData1.email2,
      Mobile: formData1.MobileNumber,
      WorkPhone1: formData1.workphone,
      WorkPhone2: formData1.workphone2,
      Fax: formData1.faxno,
      recEnable: this.numb,
      id: this.id
    };
    this.http.post (this.url + 'Company/Insert_Update_CompanyMaster', CompanyDetail) .subscribe( (data) => {
    if (data === null) {
          this.alertService.showError('Company Add Failed');
           this.disableButton = false;
       } else  {
        if (this.id == "0") {
          this.alertService.showSuccess('Company Added Successfully');
        } else {
          this.alertService.showSuccess('Company Updated Successfully');
        }
        data = data.toString().split(':');
        this.getdata = data[1].toString().split('}');
        this.id = this.getdata[0].toString();
        this.buttonname = 'Update';
        this.disableButton = false;
       }
     }
   );
  }

  FetchExistingContactOrg() {
      this.http.get(this.url + 'Company/FetchExistingCompany?id=' + this.id)
      .subscribe( (data) =>   {
          if (data == null) {
            this.alertService.showError('No Record Exist');
          } else {
            const fetchCompany: Company = JSON.parse(data.toString())[0];
            this.pageHeader = 'Update Company Master';
            this.buttonname = 'Update';
            if (fetchCompany.StateID != null) {
              this.getMaster('015', fetchCompany.StateID.toString()).subscribe( (data: any) => { this.City = data ; }); }
            this.addFormCompany.patchValue({
              companyName: fetchCompany.Name,
              address: fetchCompany.Address,
              MobileNumber: fetchCompany.Mobile,
              State: fetchCompany.StateID == null ? 0 : +fetchCompany.StateID,
              workphone: fetchCompany.WorkPhone1,
              City: fetchCompany.CityID == null ? 0 : +fetchCompany.CityID,
              workphone2: fetchCompany.WorkPhone2,
              faxno: fetchCompany.Fax,
              email1: fetchCompany.Email1,
              email2: fetchCompany.Email2
            });
          }
         }
      );
    }

    goBack() {
      window.history.back();
    }
}
